import { Component, Input } from '@angular/core';
import { Dashboard } from '../../models/dashboard.model';
import { Review } from '../../models/review.model';

@Component({
    selector: 'app-arrow-chart',
    templateUrl: './arrow-chart.component.html',
    styleUrls: ['./arrow-chart.component.css']
})
export class ArrowChartComponent {

    @Input() dashboard: Dashboard;

    @Input() review: Review | null;

    @Input() locale: string;

    get discountQueryParams() {
        return {
            country: this.review?.getPayerCountry(),
            cpa: this.review?.getCpaKey(),
            from: this.review?.getDiscountStartDate(),
            to: this.review?.getDiscountEndDate(),
            productGroup: this.review?.getDiscountProductGroup()
        };
    }

    get qualifyingRevenueQueryParams() {
        return {
            country: this.review?.getPayerCountry(),
            cpa: this.review?.getCpaKey(),
            from: this.review?.getMeasurementStartDate(),
            to: this.review?.getMeasurementEndDate(),
            productGroup: this.review?.getDiscountProductGroup()
        };
    }

}
